import { useEffect } from 'react'

import { useAppAccessState } from '../views/OAuth2App/OAuth2AppManagement/hooks'

interface McpAppAccessProbeProps {
  clientId: string
  onResolve: (clientId: string, isAccessible: boolean) => void
}

export const McpAppAccessProbe: React.FC<McpAppAccessProbeProps> = ({ clientId, onResolve }) => {
  const { isEnabled, hasAccessToApp, oauth2Enabled, appNotBlacklisted, isPending } = useAppAccessState({ clientId })

  const isAccessible = oauth2Enabled && appNotBlacklisted && isEnabled && hasAccessToApp

  useEffect(() => {
    if (!isPending) {
      onResolve(clientId, isAccessible)
    }
  }, [clientId, isAccessible, isPending, onResolve])

  return null
}
